var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModeratelyConfident(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "8em",
    width: "8em",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "strokeElem",
    stroke: "#00b5ed",
    strokeWidth: 1,
    fill: "none",
    strokeMiterlimit: 10,
    cx: 36.3,
    cy: 36.7,
    r: 23
  }), /*#__PURE__*/React.createElement("path", {
    className: "strokeElem",
    stroke: "#00b5ed",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M50.4,44.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "strokeElem",
    stroke: "#00b5ed",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M22.3,44.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "strokeElem",
    stroke: "#00b5ed",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 36.3,
    cy: 36.7,
    r: 23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "filled",
    fill: "#00b5ed",
    cx: 27.5,
    cy: 33.3,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "filled",
    fill: "#00b5ed",
    cx: 44.8,
    cy: 33.3,
    r: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "strokeElem",
    stroke: "#00b5ed",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M21.9,42.6c0,0,14.8,3.6,28.9,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "strokeElem",
    stroke: "#00b5ed",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M50.9,42.6c0,6.5-4.8,11.7-14.6,11.7c-9.7,0-14.6-5.2-14.6-11.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M22.3,46.9 c0,0,14.5,3.6,28.3,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "strokeElem",
    stroke: "#00b5ed",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M22.3,44.7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeratelyConfident);
export default __webpack_public_path__ + "static/media/moderately-confident.b614759e.svg";
export { ForwardRef as ReactComponent };